import IPFModel from '../models/ipf.model';
import Product from '../models/product.model';

let storeContent = utils.generateStore({
	showIPFModal: false,
	showIPF: false,
	showViewIPF: false,
	showPaymentOption: false,
	showTopUpButton: false,
	IPFModel,
	Product,
	activeTabIPF: 1,
	ipfPage: 4,
	loanID: '',
	ipf: null,
	requestID: '',
	payment_date: null,
	loan: {},
	bank: {},
	loanTransactions: [],
	loan_details_table: [],
	ipfRequests: [],
	charges: [],
	ipfProducts: [],
	amount: 0,
	balance: 0,
	paymentDate: 8,
	loan_tenor: '',
	product_id: '',
	loan_account_details: null,
	payment_schedules: [],
	product: {
		product_account_details: {},
		invoice_details: {},
	},
	offer: null,
});

export default {
	state() {
		return { ...storeContent.state };
	},
	getters: {
		...storeContent.getters,
	},
	mutations: {
		...storeContent.mutations,
	},
	actions: {
		async fetchIPFRequests(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'ipf_product',
						action: 'my_applications',
						data: {},
					},
					'/client',
				);

				ctx.commit('ipfRequests', res.result.client_ipf);
				Event.$emit('loader:show', false);
			} catch (err) {
				throw err;
			}
		},
		async getSelection(ctx) {
			try {
				let selected = await $session.get('selected_ipf:get');

				console.log(selected);
				if (selected) {
					// for (const intermediary of ctx.getters.intermediaries) {
					//    if(intermediary.intermediary_id === Number(selected)){
					//       ctx.dispatch('openModal',{number: 1,intermediary})
					//       // $session.remove('selected_ipf:get')
					//       return true;
					//    }
					// }
				}
			} catch (err) {
				throw err;
			}
		},
		async fetchTopupOptionsUpdate(ctx) {
			try {
				Event.$emit('loader:show', true);
				// Set account option
				let res = await api.fetchEndpointSecure(
					{
						resource: 'account',
						action: 'topup_options',
						data: {
							account_number:
								ctx.getters.loan_account_details.account_number,
							amount: ctx.getters.ipf.ipf_details.loan_amount,
						},
					},
					'/client',
				);

				let form = utils.appendSelectData({
					form: IPFModel.forms.ipfPayment,
					model: 'payment_option',
					label: 'channel_name',
					// $labelSupport: 'currency_code',
					// $label: 'available_balance',
					data: res.result.topup_options.account_topup_options,
				});

				if (form) {
					let Model = ctx.getters.IPFModel;
					Model.forms.ipfPayment = form;
					ctx.commit('IPFModel', Model);
				}
				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async updatePaymentOption(ctx, payload) {
			try {
				ctx.commit('loading', true);
				let data = payload.ref.formData_;

				if (await payload.ref.isValid()) {
					// let res = await api.fetchEndpointSecure({
					//   resource: "ipf_product",
					//   action: "add_review",
					//   data: {
					//       ipf_product_id: ctx.getters.ipf.ipf_product_details.ipf_product_id,
					//       rating: data.rating,
					//       review: data.review,
					//   }
					// }, '/client')

					ctx.commit('showPaymentOption', false);
					$notify(
						'success',
						'Payment Option Updated',
						`Payment Option successfully updated`,
						10,
					);
				}
			} catch (err) {
				throw err;
			}
			ctx.commit('loading', false);
		},
		async submitReview(ctx, payload) {
			try {
				ctx.commit('loading', true);
				let data = payload.ref.formData_;

				if (await payload.ref.isValid()) {
					let res = await api.fetchEndpointSecure(
						{
							resource: 'ipf_product',
							action: 'add_review',
							data: {
								ipf_product_id:
									ctx.getters.ipf.ipf_product_details
										.ipf_product_id,
								rating: data.rating,
								review: data.review,
							},
						},
						'/client',
					);

					ctx.commit('showAddReviews', false);
					$notify(
						'success',
						'Review Submitted',
						`Your review has been successfully submitted`,
						10,
					);
				}
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
			ctx.commit('loading', false);
		},
		async fetchIPFReviews(ctx) {
			try {
				Event.$emit('loader:show', true);

				let res = await api.fetchEndpointSecure(
					{
						resource: 'ipf_product',
						action: 'list_reviews',
						data: {
							ipf_product_id:
								ctx.getters.ipf.ipf_product_details
									.ipf_product_id,
						},
					},
					'/client',
				);

				ctx.commit('product_reviews', res.result.product_reviews);

				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		openTabIPF(ctx, page) {
			ctx.commit('activeTabIPF', page);
		},
		async initializeIPF(ctx, payload) {
			try {
				ctx.commit('ipfPage', 1);
				ctx.commit('showIPF', true);
				ctx.commit('showIPFModal', true);

				// fetch banks
				// await ctx.dispatch('fetchBanks')

				// ctx.commit('loading', false)
				// let loadId = await $session.get('viewIpf')

				// if(loadId){
				//    await ctx.dispatch('viewIPF',{loanId: loadId});
				//    await $session.remove('viewIpf')
				// }
				Event.$emit('loader:show', false);
			} catch (err) {
				throw err;
			}
		},
		async cancelRequest(ctx) {
			try {
				ctx.commit('ipfPage', 1);
			} catch (err) {
				throw err;
			}
		},
		async viewIPF(ctx, payload) {
			try {
				Event.$emit('loader:show', true);
				// Fetch IPF Details
				let res = await api.fetchEndpointSecure(
					{
						resource: 'ipf_product',
						action: 'ipf_details',
						data: {
							ipf_id: payload.ipf.ipf_id,
						},
					},
					'/client',
				);

				ctx.commit('ipf', res.result);

				// Fetch Loan Transactions
				await ctx.dispatch('fetchLoanAccountDetails');
				await ctx.dispatch('fetchLoanDetailsTable');
				// await ctx.dispatch('fetchAccounts',payload)
				// await ctx.dispatch('fetchLoanTransactions',payload)
				ctx.commit('showViewIPF', true);
				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async fetchLoanDetailsTable(ctx) {
			try {
				// let res = await api.fetchEndpointSecure(
				//   {
				//     resource: 'ipf_product',
				//     action: 'loan_account_details',
				//     data: {
				//       account_number: ctx.getters.ipf.ipf_details.ipf_loan_account,
				//     },
				//   },
				//   '/client'
				// );

				ctx.commit('loan_details_table', [
					{
						title: 'Principle',
						original: 1000,
						paid: 300,
						written_off: 20,
						overdue: 100,
						outstanding: 680,
					},
					{
						title: 'Interest',
						original: 1000,
						paid: 300,
						written_off: 20,
						overdue: 100,
						outstanding: 680,
					},
					{
						title: 'Charges',
						original: 1000,
						paid: 300,
						written_off: 20,
						overdue: 100,
						outstanding: 680,
					},
					{
						title: 'Total',
						original: 1000,
						paid: 300,
						written_off: 20,
						overdue: 100,
						outstanding: 680,
					},
				]);
			} catch (err) {
				throw err;
			}
		},
		async fetchLoanAccountDetails(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'ipf_product',
						action: 'loan_account_details',
						data: {
							account_number:
								ctx.getters.ipf.ipf_details.ipf_loan_account,
						},
					},
					'/client',
				);

				ctx.commit(
					'loan_account_details',
					res.result.loan_account_details,
				);
				ctx.commit('loanTransactions', res.result.loan_transactions);
				ctx.commit('payment_schedules', res.result.payment_schedules);
			} catch (err) {
				throw err;
			}
		},
		async fetchClientAccountBalance(ctx, accNo) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'account',
						action: 'details',
						data: {
							account_number: accNo,
						},
					},
					'/client',
				);

				ctx.commit('balance', res.result.available_balance);
			} catch (err) {
				throw err;
			}
		},
		async fetchAccounts(ctx) {
			try {
				// Set account option
				let res = await api.fetchEndpointSecure(
					{
						resource: 'account',
						action: 'get',
						data: {},
					},
					'/client',
				);

				let form = utils.appendSelectData({
					form: IPFModel.forms.ipfPay,
					model: 'account',
					label: 'account_type',
					$labelSupport: 'currency_code',
					$label: 'available_balance',
					data: res.result.client_accounts,
				});

				if (form) {
					let Model = ctx.getters.IPFModel;
					Model.forms.ipfPay = form;
					ctx.commit('IPFModel', Model);
				}

				ctx.commit('ipfPage', 2);
			} catch (err) {
				throw err;
			}
		},
		async fetchTopupOptions(ctx) {
			try {
				// Set account option
				let res = await api.fetchEndpointSecure(
					{
						resource: 'account',
						action: 'topup_options',
						data: {
							account_number:
								ctx.getters.offer.account_details
									.account_number,
							amount: ctx.getters.offer.application_details
								.loan_amount,
						},
					},
					'/client',
				);

				let form = utils.appendSelectData({
					form: IPFModel.forms.ipfPayment,
					model: 'payment_option',
					label: 'channel_name',
					// $labelSupport: 'currency_code',
					// $label: 'available_balance',
					data: res.result.topup_options.account_topup_options,
				});

				if (form) {
					let Model = ctx.getters.IPFModel;
					Model.forms.ipfPayment = form;
					ctx.commit('IPFModel', Model);
				}
			} catch (err) {
				throw err;
			}
		},
		async fetchBanks(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'underwriter',
						action: 'banks',
						data: {
							underwritter_id:
								ctx.getters.product.underwritter_id,
						},
					},
					'/client',
				);

				let form = utils.appendSelectData({
					form: IPFModel.forms.ipf,
					model: 'product',
					label: 'ipf_product_name',
					data: res.result.banks,
				});

				if (form) {
					let Model = ctx.getters.IPFModel;
					Model.forms.ipf = form;
					ctx.commit('IPFModel', Model);
				}
			} catch (err) {
				throw err;
			}
		},
		async payIPF(ctx, payload) {
			try {
				ctx.commit('loading', true);

				if (await payload.ref.isValid()) {
					let res = await api.fetchEndpointSecure(
						{
							resource: 'loan',
							action: 'repayment',
							data: {
								account_number:
									ctx.getters.ipf.ipf_details
										.ipf_loan_account,
								amount: payload.ref.formData_.amount,
							},
						},
						'/client',
					);

					ctx.commit('showViewIPF', false);
					$notify(
						'success',
						`Loan Payment Success - ${res.result.tran_ref}`,
						`Loan repayment of ${payload.ref.formData_.amount} paid`,
					);
				}

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async checkIPFEligibility(ctx, payload) {
			console.log(payload.ref.formData_);
			try {
				ctx.commit('loading', true);

				if (await payload.ref.isValid()) {
					ctx.commit('loan_tenor', payload.ref.formData_.period);
					ctx.commit('amount', payload.ref.formData_.amount);
					ctx.commit('payment_date', payload.ref.formData_.date);

					let res = await api.fetchEndpointSecure(
						{
							resource: 'ipf_product',
							action: 'application',
							data: {
								loan_amount: payload.ref.formData_.amount,
								invoice_id: ctx.getters.product.invoice_id,
								loan_tenor: payload.ref.formData_.period,
								preffered_payment_date:
									payload.ref.formData_.date,
							},
						},
						'/client',
					);

					let form = utils.appendSelectData({
						form: IPFModel.forms.ipfProduct,
						model: 'product',
						label: 'ipf_product_name',
						data: res.result.products,
					});

					if (form) {
						let Model = ctx.getters.IPFModel;
						Model.forms.ipfProduct = form;
						ctx.commit('IPFModel', Model);
					}

					ctx.commit('ipfPage', 2);
				}

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async requestIPF(ctx, payload) {
			try {
				ctx.commit('loading', true);

				if (await payload.ref.isValid()) {
					let res = await api.fetchEndpointSecure(
						{
							resource: 'ipf',
							action: 'apply',
							data: {
								invoice_id: ctx.getters.product.invoice_id,
								ipf_amount: payload.ref.formData_.amount,
								bank_id: payload.ref.formData_.bank.bank_id,
								period: payload.ref.formData_.period,
							},
						},
						'/client',
					);

					await ctx.dispatch(
						'fetchClientAccountBalance',
						res.result.invoice_details.invoice_details
							.client_account_details.account_number,
					);
					ctx.commit('ipfPage', 2);
					ctx.commit('amount', payload.ref.formData_.amount);
					ctx.commit('bank', payload.ref.formData_.bank);
					ctx.commit('loan', res.result.loan_calculation.data);
					ctx.commit('charges', res.result.ipf_charges);
					ctx.commit('loanID', res.result.ipf_details.data.loanId);
					ctx.commit('requestID', res.result.ipf_request_id);
				}

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async getOffer(ctx, payload) {
			try {
				ctx.commit('loading', true);

				if (await payload.ref.isValid()) {
					ctx.commit(
						'product_id',
						payload.ref.formData_.product.ipf_product_id,
					);
					// ctx.commit('payment_date', payload.ref.formData.date);

					let res = await api.fetchEndpointSecure(
						{
							resource: 'ipf_product',
							action: 'generate_ipf_offer',
							data: {
								invoice_id: ctx.getters.product.invoice_id,
								loan_amount: ctx.getters.amount,
								loan_tenor: ctx.getters.loan_tenor,
								ipf_product_id:
									payload.ref.formData_.product
										.ipf_product_id,
								preffered_payment_date:
									ctx.getters.payment_date,
							},
						},
						'/client',
					);

					await ctx.dispatch(
						'fetchClientAccountBalance',
						res.result.ipf_offer.account_details.account_number,
					);
					ctx.commit('offer', res.result.ipf_offer);
					await ctx.dispatch('fetchTopupOptions', {});
					ctx.commit('ipfPage', 3);
				}

				ctx.commit('loading', false);
			} catch (err) {
				if (err && err.err_code === 'INSUFFICIENT_ACCOUNT_BALANCE') {
					ctx.commit('showTopUpButton', true);
				}
				ctx.commit('loading', false);
				throw err;
			}
		},
		async acceptIPF(ctx, payload) {
			try {
				ctx.commit('loading', true);

				if (await payload.ref.isValid()) {
					let res = await api.fetchEndpointSecure(
						{
							resource: 'ipf_product',
							action: 'accept_ipf_offer',
							data: {
								invoice_id: ctx.getters.product.invoice_id,
								loan_amount: ctx.getters.amount,
								loan_tenor: ctx.getters.loan_tenor,
								ipf_product_id: ctx.getters.product_id,
								preffered_payment_date:
									ctx.getters.payment_date,
								payment_option:
									payload.ref.formData_.payment_option
										.ClientTopupOption_id,
							},
						},
						'/client',
					);

					// $notify('success', 'IPF Requested', `IPF Request for ${ctx.getters.product.product_name} was successfully requested.`)
					$notify(
						'success',
						`IPF Request Submitted - ${res.result.loan_ref}`,
						res.result.message,
					);
				}

				ctx.commit('loading', false);
				ctx.commit('showIPFModal', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
	},
};
